'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _message2 = require('linksoft/message');

var _message3 = _interopRequireDefault(_message2);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _actions = require('linksoft/core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _config = require('linksoft/core/config');

var _config2 = _interopRequireDefault(_config);

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cartService = _abp2.default.services.api.cart;
var orderService = _abp2.default.services.api.order;
var Resx = (0, _localize2.default)('Messages');

var cartActions = {

    changeAmount: function changeAmount(item) {
        return (0, _extends3.default)({
            type: _actionTypes2.default.CHANGE_AMOUNT }, item);
    },

    sortItems: function sortItems(propName) {
        var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';

        return {
            type: _actionTypes2.default.SORT_ITEMS,
            propName: propName,
            direction: direction
        };
    },

    // submit
    submitChanges: function submitChanges(item, noRefresh) {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.processing) {
                return;
            }
            var items = (0, _isObject2.default)(item) ? [item] : (0, _values2.default)(state.cart.changes).map(function (v) {
                return {
                    productId: v.productId,
                    amount: v.amount,
                    customerId: v.customerId
                };
            });

            // allow to add only if amount of currently added product is > 0 and also is not currently in cart
            if (cartActions.checkZeroNewAmount(state, item)) return;

            if (noRefresh && item) {
                cartService.updateCartNoRefresh(items, state.cart.isCompact).done(function (result) {
                    if (result.success && (result.updateResults || []).length > 0) {
                        cartActions.updateCartNoRefreshSuccess(state, item, dispatch, result.updateResults[0]);
                    } else {
                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                    }
                }).fail(function () {
                    dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                });
            } else {
                dispatch({ type: _actionTypes2.default.SUBMIT_CHANGES, items: items });
                cartService.update(items, state.cart.isCompact).done(function (result) {
                    dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
                }).fail(function () {
                    dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                });
            }
        };
    },
    checkZeroNewAmount: function checkZeroNewAmount(state, item) {
        // allow to add only if amount of currently added product is > 0 and also is not currently in cart
        if (!state || !state.cart || !state.cart.items || !item) return false;
        var productInCart = state.cart.items.some(function (i) {
            return ((i.productId || -1) === item.productId || (i.cartItemId || -1) === item.cartItemId) && i.amount > 0;
        });
        return item.amount === 0 && !productInCart;
    },
    updateCartNoRefreshSuccess: function updateCartNoRefreshSuccess(state, item, dispatch, updateResult) {
        var updatedCart = (0, _extends3.default)({}, state.cart);
        updatedCart.changedProductId = item.productId;

        if (!updateResult.changes.some(function (ur) {
            return ur.productId === item.productId;
        })) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = (0, _getIterator3.default)(updateResult.messages || [Resx.Messages.CannotAddToCart]), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var _message = _step.value;

                    _notify2.default.warn(_message);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        } else {
            cartActions.addItemToCart(updatedCart.items, item);
            cartActions.addItemToCart(updatedCart.itemAmounts, item);
            cartActions.sumTotalPrice(updatedCart);

            var cartChangeObject = { productId: item.productId, customerId: item.customerId };
            var key = (0, _linksoftAlbatros.getCartChangeKey)(cartChangeObject);
            delete updatedCart.changes[key];

            dispatch({ type: _actionTypes2.default.UPDATE, cart: updatedCart });
        }
    },

    addItemToCart: function addItemToCart(collection, item, addPriceObject) {
        var foundCartItem = collection.find(function (it) {
            return it.productId === item.productId;
        });
        if (!foundCartItem) {
            collection.push(item);
        } else if (item.amount === 0) {
            collection.splice(collection.indexOf(foundCartItem), 1);
        } else {
            foundCartItem.amount = item.amount;
        }
    },

    sumTotalPrice: function sumTotalPrice(cart) {
        var finalPrice = 0,
            finalPriceNoVat = 0;
        var totalPriceCommission = 0,
            totalPriceCommissionNoVat = 0;
        var totalPriceInvoice = 0,
            totalPriceInvoiceNoVat = 0;

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = (0, _getIterator3.default)(cart.items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                var unitPrice = item.price.unitPrice;
                var productTotalPrice = item.price.totalPrice || {};
                var finalProductPrice = unitPrice.finalPrice * item.amount || productTotalPrice.finalPrice;
                var finalProductPriceNoVat = unitPrice.finalPriceWithoutVat * item.amount || productTotalPrice.finalPriceWithoutVat;
                finalPrice += finalProductPrice;
                finalPriceNoVat += finalProductPriceNoVat;

                if (item.commission) {
                    totalPriceCommission += finalProductPrice;
                    totalPriceCommissionNoVat += finalProductPriceNoVat;
                } else {
                    totalPriceInvoice += finalProductPrice;
                    totalPriceInvoiceNoVat += finalProductPriceNoVat;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        cart.totalPrice.finalPrice = finalPrice;
        cart.totalPrice.finalPriceWithoutVat = finalPriceNoVat;
        cart.totalVat = finalPrice - finalPriceNoVat;
        cart.totalPriceCommission.finalPrice = totalPriceCommission;
        cart.totalPriceCommission.finalPriceWithoutVat = totalPriceCommissionNoVat;
        cart.totalPriceInvoice.finalPrice = totalPriceInvoice;
        cart.totalPriceInvoice.finalPriceWithoutVat = totalPriceInvoiceNoVat;
        cart.canCreateOrder = cart.totalPrice.finalPrice > 0;
    },

    // update cart state (usually comes from server)
    update: function update(cart) {
        return { type: _actionTypes2.default.UPDATE, cart: cart };
    },

    // load cart data from server (used for initialization)
    loadData: function loadData() {
        return function (dispatch, getState) {
            dispatch({ type: _actionTypes2.default.LOAD_DATA });

            cartService.getCart(getState().cart.isCompact).done(function (result) {
                dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
            }).fail(function () {
                dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
            });
        };
    },

    addByEan: function addByEan(ean, amount) {
        return { type: _actionTypes2.default.ADD_BY_EAN, ean: ean, amount: amount };
    },

    empty: function empty() {
        return function (dispatch, getState) {
            var state = getState();
            if (state.cart.processing) {
                return;
            }
            _message3.default.confirm(Resx.Messages.ConfirmClearCart, Resx.Messages.ConfirmTitle, function (isConfirmed) {
                if (isConfirmed) {
                    cartService.clear(state.cart.isCompact).done(function (result) {
                        dispatch({ type: _actionTypes2.default.UPDATE, cart: result });

                        var element = document.getElementById('emptyCartButton');
                        element.className = 'btn btn-grey disabled';
                    }).fail(function () {
                        dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                    });
                } else {
                    var element = document.getElementById('emptyCartButton');
                    element.className = 'btn btn-grey';
                }
            });
        };
    },

    addSelectedItem: function addSelectedItem(itemToSelect) {
        return function (dispatch, getState) {
            var state = getState();
            var updatedCart = (0, _extends3.default)({}, state.cart);

            var cartItem = updatedCart.items.find(function (i) {
                return i.productId === itemToSelect.productId;
            });
            if (!cartItem) return;

            cartItem.selectedRow = !itemToSelect.originalSelection;
            dispatch({ type: _actionTypes2.default.UPDATE, cart: updatedCart });
        };
    },

    deleteBatch: function deleteBatch() {
        return function (dispatch, getState) {
            var state = getState();
            var updatedCart = (0, _extends3.default)({}, state.cart);
            var itemsToRemove = updatedCart.items.filter(function (i) {
                return i.selectedRow;
            });

            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;

            try {
                var _loop = function _loop() {
                    var item = _step3.value;

                    updatedCart.items.splice(updatedCart.items.indexOf(item), 1);
                    updatedCart.itemAmounts.splice(updatedCart.itemAmounts.find(function (ia) {
                        return ia.id === item.id;
                    }));
                };

                for (var _iterator3 = (0, _getIterator3.default)(itemsToRemove), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    _loop();
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                        _iterator3.return();
                    }
                } finally {
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }

            var removedItemsPostObject = itemsToRemove.map(function (m) {
                return { cartItemId: m.id, productId: m.productId, amount: 0 };
            });

            cartService.updateCartNoRefresh(removedItemsPostObject, state.cart.isCompact).done(function (result) {
                if (result.success) {
                    cartActions.sumTotalPrice(updatedCart);
                    dispatch({ type: _actionTypes2.default.UPDATE, cart: updatedCart });
                } else {
                    dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
                }
            }).fail(function () {
                dispatch({ type: _actionTypes2.default.UPDATE_FAILED });
            });
        };
    },

    sendOrder: function sendOrder(e) {
        return function (dispatch) {

            cartActions.enableDisableSubmitButton(true);
            var customOrder = (document.getElementById('customOrderIdentifier') || {}).value;
            var salesmanNote = (document.getElementById('salesmanNote') || {}).value;
            var identifiers = (0, _stringify2.default)({ customOrder: customOrder, salesmanNote: salesmanNote });

            orderService.sendOrder(e.token, identifiers).done(function (result) {
                if (result.success === true) {
                    orderService.finishOrder(result.invoiceOrderId, result.commissionOrderId).done(function () {
                        window.location.href = (0, _config2.default)().url.cartSuccess({ token: result.token });
                        e.done();
                    }).fail(function () {
                        cartActions.orderFailedProcess(e, dispatch);
                    });
                } else if (Array.isArray(result.messages)) {
                    result.messages.forEach(function (i) {
                        return console.error(i);
                    });
                    cartActions.orderFailedProcess(e, dispatch);
                } else {
                    cartActions.orderFailedProcess(e, dispatch);
                }
            }).fail(function () {
                cartActions.orderFailedProcess(e, dispatch);
            });
        };
    },

    orderFailedProcess: function orderFailedProcess(e, dispatch) {
        _notify2.default.warn(Resx.Messages.AjaxProcessingError || 'Error');
        dispatch({ type: _actionTypes2.default.ORDER_FAILED });
        e.done();
        cartActions.enableDisableSubmitButton(false);
    },


    enableDisableSubmitButton: function enableDisableSubmitButton(modifier) {
        var btnSubmitOrder = document.getElementById('btnSubmitOrder');
        if (btnSubmitOrder) btnSubmitOrder.disabled = !!modifier;
    },

    saveOptions: function saveOptions(options) {
        return function (dispatch) {
            dispatch({ type: _actionTypes2.default.OPTIONS_CHANGED, options: options });
            if (optionsChangingHandler) clearTimeout(optionsChangingHandler);
            optionsChangingHandler = setTimeout(function () {
                cartService.saveOptions(options).done(function (result) {
                    _abp2.default.log.debug('OPTIONS SAVED');
                    _abp2.default.log.debug(options);
                    dispatch({ type: _actionTypes2.default.UPDATE, cart: result });
                });
            }, 1000);
        };
    }
};

var optionsChangingHandler = 0;

_actions2.default.add('cart', cartActions);

exports.default = cartActions;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/actions.js
// module id = 71
// module chunks = 0